import { useMemo } from 'react';

import { usePetitionDetailsPageData, usePetitionDetailsPageUserData } from '#src/app/pages/petitionDetails/pageContext';
import type { ShareActionsOptions } from '#src/app/shared/hooks/share';
import { useNativeShareTitle } from '#src/app/shared/hooks/share';

import { useGetPetitionShareContent } from './content';
import { useOnPetitionShareSuccess } from './success';
import { useGetPetitionShareTrackingData } from './tracking';

export function usePetitionShareOptions(): ShareActionsOptions {
	const getContent = useGetPetitionShareContent();
	const getTrackingData = useGetPetitionShareTrackingData();
	const onSuccess = useOnPetitionShareSuccess();
	const {
		data: {
			experiments: { nativeShareTitleExperiment },
		},
	} = usePetitionDetailsPageUserData();
	const {
		data: {
			petition: { displayTitle },
		},
	} = usePetitionDetailsPageData();
	const mobileNativeShare = useNativeShareTitle({
		experiment: nativeShareTitleExperiment,
		surface: 'petition_show',
		petitionTitle: displayTitle,
	});

	return useMemo(
		() => ({
			trackingEventName: 'share_petition',
			getContent,
			getTrackingData,
			onSuccess,
			config: { mobileNativeShare },
		}),
		[getContent, getTrackingData, onSuccess, mobileNativeShare],
	);
}
